import UserForm from '../components/UserForm';
import UserMutationProvider from '../contexts/userMutationContext';

const CreateUserPage = () => {
  return (
    <UserMutationProvider>
      <UserForm mode="create" />
    </UserMutationProvider>
  );
};

export default CreateUserPage;
